var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"tanggal mt-3 text-right monaco"},[(_vm.waktu == '')?_c('em',{staticClass:"text-muted"},[_vm._v("memuat waktu")]):_c('span',[_vm._v(_vm._s(_vm.waktu)+" "+_vm._s(_vm.tanggal))])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }